export default __webpack_public_path__ + "static/media/cross-icon.d84b8dec.svg";